import {
  getAvailableLendersByLenderCommissions,
  isThereAnyContactWhoIsCompanyOrSelfEmployed,
  areAllContactsCompanies
} from '__core/shared/util/salestrekker';
/* @ngInject */

export default (
  $rootScope,
  $scope,
  $state,
  $stateParams,
  $timeout,
  $mdDialog,
  $mdUtil,
  $location,
  $anchorScroll,
  $q,
  cookies,
  webpage,
  authenticationService,
  eventService,
  dateTimeService,
  jsonFactory,
  helperService,
  pdfService,
  accountService,
  Contact,
  contactService,
  contactsService,
  expensesService,
  incomeService,
  Asset,
  Ownership,
  assetsService,
  LabelType,
  Liability,
  liabilitiesService,
  Insurance,
  insurancesService,
  otherAdvisersService,
  ticketService,
  ticketsService,
  TicketStatusHistory,
  workflowService,
  labelsService,
  Objective,
  AssetFinance,
  AssetFinanceDetail,
  AssetFinanceSearchProduct,
  AssetFinanceCompareProduct,
  AssetFinanceCompliance,
  AssetFinanceVerificationApplicant,
  AssetFinanceInsurance,
  AssetFinanceProposal,
  assetFinanceService,
  lendersService,
  productsService,
  Commission,
  commissionsService,
  documentService,
  documentsService,
  notesService,
  homeLoanService,
  lodgementsService,
  lodgementService,
  validationService,
  uiService,
  openBankingService,
  DOCUMENT
) => {
  $scope.Model = {
    hasBrokerToolsEnabled: $rootScope.hasBrokerToolsEnabled(),
    countries: [],
    organizationCountry: helperService.getOrganizationCountry(),
    currentTicket: {},
    currentWorkflow: {},
    currentTicketOwner: {},
    currentTicketAssetFinance: {},
    currentGateway: {},
    availableContacts: [],
    availablePersonOnlyContacts: [],
    availableCompanyOnlyContacts: [],
    availableNonBorrowingSpouses: [],
    availableSecurityGuarantors: [],
    availableServicingGuarantors: [],
    availableIncomeContacts: [],
    availableExpensesContacts: [],
    availableSpouses: [],
    availableNotes: [],
    availableDocuments: [],
    availableComplianceTypes: _.sortBy(DOCUMENT.TYPES, 'value'),
    availableLenders: [],
    filteredLenders: [],
    availableLendersPerCountry: [],
    availableLendersDocuments: [],
    availableProducts: [],
    availableCommissions: [],
    selectedCommission: [],
    availableLabels: [],
    availableIncomeTypes: incomeService.getAvailableIncomeTypes(),
    availableAssetTypes: assetsService.getAvailableAssetTypes(),
    availableLiabilityTypes: [],
    availableInsuranceTypes: [],
    availableOtherAdviserTypes: [],
    activeSection: 'applicant0',
    availableSections: [],
    factFindSections: [
      'income',
      'expenses',
      'assets',
      'liabilities',
      'needsAndObjectives',
      'insurance',
      'otherAdvisers'
    ],
    assetFinanceSections: [
      'assetDetails',
      'lenderAndProduct',
      'compareProducts',
      'financeProposal',
      'commissions',
      'compliance',
      'preliminaryAssessment',
      'lodgement'
    ],
    isSidebarMinimized:
      cookies.get('stSidebar') && cookies.get('stSidebar') !== undefined
        ? cookies.get('stSidebar')
        : false,
    validation: {
      errors: [],
      incomeErrors: [],
      expensesErrors: [],
      assetsErrors: [],
      liabilitiesErrors: [],
      assetToBeFinancedErrors: [],
      bidErrors: []
    },
    openBankingData: [],
    openBankingContacts: [],
    isReady: false,
    availableAddresses: [],
    attachments: [],
    attachmentsFiles: [],
    attachmentsCompliance: [],
    availableAssetFinanceInsuranceTypes:
      assetFinanceService.getAvailableAssetFinanceInsuranceTypes(),
    availablePdfTypes: helperService.getAvailablePdfTypes()
  };

  /*
   * Set webpage Title
   * --------------------------------------------------------------------------------
   */
  webpage.pageTitle('Loading, please wait');

  /*
   * Methods
   * --------------------------------------------------------------------------------
   */
  const loadLendersPerCountry = () => {
    const deferred = $q.defer();
    lendersService
      .getAvailable({
        cca2: [$scope.Model.organizationCountry.cca2]
      })
      .then((lenders) => {
        if (lenders && lenders.length) {
          $scope.Model.availableLendersPerCountry = lenders;
        }
        deferred.resolve(lenders);
      });
    return deferred.promise;
  };

  const loadLabels = () => {
    labelsService
      .getAvailable({
        orderBy: 'name',
        coerceTo: 'string',
        isDescending: false,
        isActive: true
      })
      .then((labels) => {
        $scope.Model.availableLabels = labels;
        $scope.Model.availableFileLabels = labels.filter(
          (l) => l.type.name === LabelType.file.name && l.isLocked
        );
        $scope.Model.availableContactLabels = labels.filter(
          (l) => l.type.name === LabelType.contact.name
        );
        $scope.Model.availableComplianceFileLabels = _.filter(
          labels,
          (l) => l.type.name === LabelType.file.name && l.isLocked
        );
      });
  };

  const loadCountries = () => {
    const deferred = $q.defer();
    jsonFactory.getCountries().then((data) => {
      $scope.Model.countries = data;
      deferred.resolve(data);
    });
    return deferred.promise;
  };

  const loadOccupations = () => {
    const deferred = $q.defer();
    jsonFactory.getOccupations().then((data) => {
      $scope.Model.occupations = data;
      deferred.resolve(data);
    });
    return deferred.promise;
  };

  const loadIndustries = () => {
    const deferred = $q.defer();
    jsonFactory.getIndustries().then((data) => {
      $scope.Model.industries = data;
      deferred.resolve(data);
    });
    return deferred.promise;
  };

  const loadWorkflow = () => {
    workflowService.readWorkflow({ id: $stateParams.id }).then((workflow) => {
      $scope.Model.currentWorkflow = workflow;
    });
  };

  const loadTicket = (idTicket) => {
    const deferred = $q.defer();
    ticketService.readTicket({ id: idTicket }).then((ticket) => {
      $scope.Model.currentTicket = ticket;
      deferred.resolve(ticket);
    });
    return deferred.promise;
  };

  const loadAccount = (idOwner) => {
    const deferred = $q.defer();
    accountService.readAccount({ id: idOwner }).then((account) => {
      $scope.Model.currentTicketOwner = account;
      deferred.resolve(account);
    });
    return deferred.promise;
  };

  const loadContacts = (idContacts) => {
    const deferred = $q.defer();
    contactsService.getSpecific({ idContacts, isActive: true }).then((contacts) => {
      $scope.Model.availableContacts = _.compact($scope.sortByIdContacts(contacts));
      if ($scope.Model.availableContacts?.length) {
        $scope.Model.availablePersonOnlyContacts = _.filter(
          $scope.Model.availableContacts,
          (c) => !c.isCompany
        );
        $scope.Model.availableCompanyOnlyContacts = _.filter(
          $scope.Model.availableContacts,
          (c) => c.isCompany
        );
        $scope.Model.availableNonBorrowingSpouses = _.filter(
          $scope.Model.availableContacts,
          (c) =>
            helperService.isClientNonBorrowingSpouse({
              ticketClientTypes: $scope.Model.currentTicket.ticketClientTypes,
              idContact: c.id
            })
        );
        $scope.Model.availableSecurityGuarantors = _.filter(
          $scope.Model.availableContacts,
          (c) =>
            helperService.isClientSecurityGuarantor({
              ticketClientTypes: $scope.Model.currentTicket.ticketClientTypes,
              idContact: c.id
            })
        );
        $scope.Model.availableSecurityGuarantors = _.filter(
          $scope.Model.availableContacts,
          (c) =>
            helperService.isClientServicingGuarantor({
              ticketClientTypes: $scope.Model.currentTicket.ticketClientTypes,
              idContact: c.id
            })
        );
      }
      deferred.resolve(contacts);
    });
    return deferred.promise;
  };

  const loadSpouses = (idContacts) => {
    contactsService.getSpecific({ idContacts, isActive: true }).then((spouses) => {
      $scope.Model.availableSpouses = spouses;
    });
  };

  const loadCommissions = () => {
    const deferred = $q.defer();
    commissionsService.getAvailable({ isActive: true }).then((data) => {
      if (data.length) {
        const commissionBlank = Commission.blank();
        commissionBlank.id = '';
        commissionBlank.name = 'Select one';
        data.unshift(commissionBlank);
        $scope.Model.availableCommissions = data;
      }
      deferred.resolve(data);
    });
    return deferred.promise;
  };

  const loadLendersDocuments = (idLenders) => {
    lendersService
      .getDocuments({ idLenders, types: ['LOGO', 'CALCULATOR'] })
      .then((lendersDocuments) => {
        if (lendersDocuments?.length) {
          $scope.Model.availableLendersDocuments = lendersDocuments;
        }
      });
  };

  const loadLenders = (currentTicketOwner) => {
    const deferred = $q.defer();
    lendersService
      .getAvailable({
        cca2: [$scope.Model.organizationCountry.cca2],
        type: 'ASSET_FINANCE'
      })
      .then((lenders) => {
        if (lenders?.length) {
          $scope.Model.availableLenders = getAvailableLendersByLenderCommissions(
            lenders,
            $rootScope.CurrentOrganization,
            currentTicketOwner,
            $scope.Model.currentWorkflow,
            $rootScope.IsEnterprise,
            $scope.Model.currentAssetFinance?.isCommercial || false
          );
          if ($scope.Model.availableLenders?.length) {
            $scope.Model.filteredLenders = $scope.Model.availableLenders;
            const idLenders = _.compact(_.uniq(_.map($scope.Model.availableLenders, 'id')));
            loadLendersDocuments(idLenders);
          }
        }
        deferred.resolve(lenders);
      });
    return deferred.promise;
  };

  const loadAssetFinance = (idAssetFinance) => {
    const deferred = $q.defer();
    assetFinanceService.readAssetFinance({ id: idAssetFinance }).then((assetFinance) => {
      $scope.Model.currentAssetFinance = assetFinance;
      deferred.resolve(assetFinance);
    });
    return deferred.promise;
  };

  const loadDocuments = () => {
    documentsService.getAvailable({ isActive: true }).then((documents) => {
      $scope.Model.availableDocuments = documents;
    });
  };

  const loadNotes = () => {
    const deferred = $q.defer();
    notesService
      .getSpecific({ idTickets: $scope.Model.currentTicket.id, isActive: true })
      .then((notes) => {
        $scope.Model.availableNotes = notes;
        deferred.resolve(notes);
      });
    return deferred.promise;
  };

  const loadAttachments = (notes) => {
    $timeout(() => {
      let noteAttachments = notes.map((note) => {
        const attachments = [];
        if (note.attachments.length > 0) {
          for (let a = 0; a < note.attachments.length; a += 1) {
            const attach = note.attachments[a];
            attach.idNote = note.id;
            attach.noteType = note.type;
            if (_.find(attachments, (s) => s.id === attach.id) === undefined) {
              attachments.push(attach);
            }
          }
          return attachments;
        }
        return attachments;
      });
      noteAttachments = _.flatten(noteAttachments);
      if ($scope.isDealOwnerBroker() && $scope.Model.hasBrokerToolsEnabled) {
        $scope.Model.attachmentsFiles = _.union(
          $scope.Model.currentTicket.attachments,
          noteAttachments
        );
        if ($scope.Model.attachmentsFiles.length) {
          const complianceIdLabels = $scope.Model.availableFileLabels.map((a) => a.id);
          $scope.Model.attachmentsCompliance = $scope.Model.attachmentsFiles.filter(
            (a) =>
              _.find(
                a.idLabels,
                (l) => complianceIdLabels.indexOf(l) > -1 && a?.noteType?.name !== 'video'
              ) !== undefined
          );
        }
        if ($scope.Model.attachmentsCompliance.length) {
          const attachmentComplianceIds = $scope.Model.attachmentsCompliance.map((a) => a.id);
          $scope.Model.attachmentsFiles = $scope.Model.attachmentsFiles.filter(
            (a) => attachmentComplianceIds.indexOf(a.id) === -1 && a?.noteType?.name !== 'video'
          );
        }
        $scope.Model.attachments = $scope.Model.attachmentsFiles.concat(
          $scope.Model.attachmentsCompliance
        );
      }
    });
  };

  const loadOpenBanking = () => {
    const deferred = $q.defer();
    if (
      $rootScope.isDev() &&
      $scope.Model.currentTicket?.openBanking?.length &&
      $scope.Model.currentTicket?.sharedWith?.clientProfile?.length
    ) {
      const idTicket = $scope.Model.currentTicket?.id;
      const idContacts = [];
      const len = $scope.Model.currentTicket?.sharedWith?.clientProfile?.length || 0;
      for (let c = 0; c < len; c += 1) {
        const clientProfile = $scope.Model.currentTicket?.sharedWith?.clientProfile[c];
        const openBanking = _.find(
          $scope.Model.currentTicket?.openBanking || [],
          (o) => o?.idContact === clientProfile?.idClient && o?.isFinished && o?.hasData
        );
        if (
          clientProfile?.integrations?.isOpenBankingEnabled &&
          _.indexOf(
            $scope.Model.currentTicket?.sharedWith?.idClientsWithAccess || [],
            clientProfile?.idClient
          ) > -1 &&
          openBanking
        ) {
          idContacts.push(clientProfile?.idClient);
        }
      }
      deferred.resolve([]);
    } else {
      deferred.resolve([]);
    }
    return deferred.promise;
  };

  const initialize = () => {
    loadLendersPerCountry();
    loadLabels();
    loadWorkflow();
    loadCountries()
      .then(() => {
        if ($scope.Model.organizationCountry.cca2 === 'AU') {
          return $q.all(loadOccupations(), loadIndustries());
        }
        return true;
      })
      .then(() => {
        loadTicket($stateParams.dd).then(() => {
          webpage.pageTitle($scope.Model.currentTicket?.getName());
          if ($scope.Model.currentTicket?.idAssetFinance) {
            loadContacts($scope.Model.currentTicket?.idClients || []).then(() => {
              loadOpenBanking().then(() => {
                for (let c = 0; c < $scope.Model?.availableContacts?.length; c += 1) {
                  $scope.Model.availableSections.push(`applicant${c}`);
                }

                if (!$scope.showIncome()) {
                  const idx = $scope.Model.factFindSections.indexOf('income');
                  $scope.Model.factFindSections.splice(idx, 1);
                }
                if (!$scope.showExpenses()) {
                  const idx = $scope.Model.factFindSections.indexOf('expenses');
                  $scope.Model.factFindSections.splice(idx, 1);
                }

                let idSpouses = _.map(
                  _.filter(
                    $scope.Model.availablePersonOnlyContacts || [],
                    (c) =>
                      c?.person?.information?.idSpouse &&
                      c?.person?.information?.idSpouse !== ''
                  ),
                  (s) => s?.person?.information?.idSpouse
                );
                idSpouses = _.uniq(_.compact(idSpouses));

                if (idSpouses?.length) {
                  loadSpouses(idSpouses);
                }

                for (let a = 0; a < $scope.Model.currentTicket?.assets?.length; a += 1) {
                  if (!$scope.Model.currentTicket?.assets[a]?.ownership?.length) {
                    $scope.Model.currentTicket.assets[a].ownership =
                      helperService.setOwnershipOfAssetOrLiability(
                        $scope.Model.availableContacts,
                        false
                      );
                  }
                }
                for (let l = 0; l < $scope.Model.currentTicket?.liabilities?.length; l += 1) {
                  if (!$scope.Model.currentTicket?.liabilities[l]?.ownership?.length) {
                    $scope.Model.currentTicket.liabilities[l].ownership =
                      helperService.setOwnershipOfAssetOrLiability(
                        $scope.Model.availableContacts,
                        false
                      );
                  }
                }
                loadAssetFinance($scope.Model.currentTicket.idAssetFinance).then(() => {
                  if (
                    !$scope?.Model?.currentAssetFinance?.isCommercial &&
                    _.isEmpty($scope.Model.currentGateway) &&
                    $scope.Model.organizationCountry?.cca2 !== 'NZ'
                  ) {
                    $scope.validate();
                  }
                  $scope.getLiabilityTypes();
                  $scope.getInsuranceTypes();
                  $scope.getOtherAdviserTypes();
                  if (!$scope.showObjectivesInsurancesAndOtherAdvisers()) {
                    const oIdx = $scope.Model.factFindSections.indexOf('needsAndObjectives');
                    $scope.Model.factFindSections.splice(oIdx, 1);
                    const iIdx = $scope.Model.factFindSections.indexOf('insurance');
                    $scope.Model.factFindSections.splice(iIdx, 1);
                    const oAIdx = $scope.Model.factFindSections.indexOf('otherAdvisers');
                    $scope.Model.factFindSections.splice(oAIdx, 1);
                  }
                  $scope.Model.availableSections = $scope.Model.availableSections.concat(
                    $scope.Model.factFindSections
                  );
                  $scope.Model.availableSections = $scope.Model.availableSections.concat(
                    $scope.Model.assetFinanceSections
                  );

                  loadAccount($scope.Model.currentTicket.idOwner).then(() => {
                    loadLenders($scope.Model.currentTicketOwner).then(() => {
                      if (
                        $scope.hasAssetFinanceTools() &&
                        $scope.isLenderExistingInTicketOwnersLenderAccreditations()
                      ) {
                        _.forEach($scope?.Model?.currentAssetFinance?.assetDetails, (a) => {
                          if (a?.vendor?.idContact) {
                            contactService
                              .readContact({ id: a.vendor.idContact })
                              .then((data) => {
                                if (data) {
                                  $scope.changeSelectedItemOfVendor(a, data);
                                } else {
                                  const contact = Contact.blank();
                                  contact.id = '';
                                  $scope.changeSelectedItemOfVendor(a, contact);
                                }
                              });
                          }
                        });
                        if ($scope.Model.currentAssetFinance?.isCommercial) {
                          const aIdx =
                            $scope.Model.availableSections.indexOf('needsAndObjectives');
                          $scope.Model.availableSections.splice(
                            aIdx,
                            0,
                            'assetCommitmentSchedule'
                          );
                          const cIdx = $scope.Model.availableSections.indexOf('commissions');
                          $scope.Model.availableSections.splice(cIdx, 1);
                        }
                        loadDocuments();
                        $scope.verificationsApplicantsIdentified();
                        loadNotes().then(() => {
                          loadAttachments($scope.Model.availableNotes);
                          $scope.getAllAddresses();
                          if (
                            !$scope.Model.currentAssetFinance?.isCommercial &&
                            !$scope.Model.currentAssetFinance?.commission?.idCommission
                          ) {
                            loadCommissions().then(() => {
                              $scope.Model.currentAssetFinance.commission =
                                assetFinanceService.setCommission({
                                  commission: $scope.Model.currentAssetFinance?.commission,
                                  financeProposal:
                                    $scope.Model.currentAssetFinance?.financeProposal,
                                  commissions: $scope.Model.availableCommissions,
                                  isInitial: true
                                });
                              if (
                                $scope?.Model?.currentAssetFinance?.commission?.idCommission
                              ) {
                                $scope.saveAssetDetails({
                                  commission: $scope.Model.currentAssetFinance.commission
                                });
                              }
                              $scope.Model.isReady = true;
                            });
                          } else {
                            loadCommissions().then(() => {
                              $scope.Model.isReady = true;
                            });
                          }
                        });
                      } else {
                        $state.transitionTo('factFind', {
                          id: $stateParams.id,
                          dd: $stateParams.dd
                        });
                      }
                    });
                  });
                });
              });
            });
          } else {
            $state.transitionTo('factFind', {
              id: $stateParams.id,
              dd: $stateParams.dd
            });
          }
        });
      });
  };

  initialize();

  /*
   * Asset finance ~ Switch UI Section
   * --------------------------------------------------------------------------------
   */
  $scope.showSection = (section) => {
    $scope.Model.activeSection = section;
  };

  $scope.getNumberOfSection = (section) => {
    const idx = $scope.Model.availableSections.indexOf(section);
    return idx + 1;
  };

  $scope.previous = (section) => {
    const idx = $scope.Model.availableSections.indexOf(section);
    $scope.Model.activeSection =
      section !== 'applicant0' ? $scope.Model.availableSections[idx - 1] : section;
    $scope.showSection($scope.Model.activeSection);
    $location.hash('top');
    $anchorScroll();
  };

  $scope.next = (section) => {
    const idx = $scope.Model.availableSections.indexOf(section);
    $scope.Model.activeSection =
      $scope.Model.availableSections[idx + 1] !== undefined
        ? $scope.Model.availableSections[idx + 1]
        : $scope.Model.availableSections[idx];
    $scope.showSection($scope.Model.activeSection);
    $location.hash('top');
    $anchorScroll();
  };

  $scope.isNextDisabled = () => {
    const idx = $scope.Model.availableSections.indexOf($scope.Model.activeSection);
    if ($scope.Model.availableSections[idx + 1] === 'gateway' && !$scope.isLodgementEnabled()) {
      return true;
    }
    return (
      !$scope.Model.availableSections[idx + 1] ||
      ($scope.Model.activeSection === 'compareProducts' && $scope.hasNoPreferredProduct())
    );
  };

  /*
   * Asset finance ~ Helpers
   * --------------------------------------------------------------------------------
   */
  $scope.isDealOwnerBroker = () =>
    authenticationService.isBroker($scope.Model.currentTicket.idOwner);

  $scope.hasAssetFinanceTools = () =>
    $scope.isDealOwnerBroker() &&
    $rootScope.hasBrokerToolsEnabled() &&
    $scope.Model.filteredLenders.length &&
    $scope.Model.currentWorkflow.isAssetFinance() &&
    $rootScope.canSeeAssetFinanceTools();

  $scope.isLenderExistingInTicketOwnersLenderAccreditations = () => {
    let isExisted = false;
    if (
      $scope.hasAssetFinanceTools() &&
      $scope.Model.currentTicketOwner?.lenderAccreditations?.length
    ) {
      const preferredProduct = assetFinanceService.getPreferredProduct(
        $scope.Model.currentAssetFinance.compareProducts
      );
      let lender;
      if (preferredProduct?.selectedProduct?.lender?.length) {
        lender = _.find(
          $scope.Model.currentTicketOwner.lenderAccreditations,
          (l) => l.idLender === preferredProduct.selectedProduct.lender[0].id
        );
        isExisted = lender !== undefined;
      } else {
        isExisted = true;
      }
    } else {
      isExisted = true;
    }
    return isExisted;
  };

  $scope.isDealOwnerMentee = () =>
    $rootScope.CurrentOrganization.mentees &&
    $rootScope.CurrentOrganization.mentees[$scope.Model.currentTicket.idOwner] !== undefined &&
    $rootScope.CurrentOrganization.mentees[$scope.Model.currentTicket.idOwner].length > 0;

  $scope.isDealOwnerHasMentor = () =>
    $rootScope.CurrentOrganization.mentees &&
    $rootScope.CurrentOrganization.mentees[$scope.Model.currentTicket.idOwner] &&
    $rootScope.CurrentOrganization.mentees[$scope.Model.currentTicket.idOwner].indexOf(
      $rootScope.CurrentAccount.id
    ) > -1 &&
    authenticationService.isBroker($rootScope.CurrentAccount.id);

  $scope.showAssetFinanceTools = () =>
    $scope.Model.isReady &&
    $scope.isDealOwnerBroker() &&
    $scope.Model.hasBrokerToolsEnabled &&
    $scope.Model.filteredLenders.length &&
    $scope.Model.currentWorkflow.isAssetFinance();

  $scope.sortByIdContacts = (contacts) => {
    const sortedContacts = [];
    $scope.Model.currentTicket.idClients.forEach((id) => {
      const contact = contacts.find((c) => c.id === id);
      sortedContacts.push(contact);
    });
    return sortedContacts;
  };

  $scope.setCaretClass = (isView) =>
    `${ticketService.setCaretClass(isView)} ${
      $scope.Model.isSidebarMinimized || !$rootScope.IsMedia('gt-sm') ? 'hide' : ''
    }`;

  $scope.toggleSidebar = () => {
    $scope.Model.isSidebarMinimized = !$scope.Model.isSidebarMinimized;
    if ($scope.Model.isSidebarMinimized) {
      cookies.set('stSidebar', btoa('sidebar is minimized'), {
        path: '/'
      });
    } else {
      cookies.remove('stSidebar', { path: '/' });
    }
  };

  $scope.getPreferredProduct = () =>
    assetFinanceService.getPreferredProduct($scope.Model.currentAssetFinance.compareProducts);

  $scope.hasNoPreferredProduct = () => $scope.getPreferredProduct() === undefined;

  $scope.areAllClientsNonBorrowingSpouse = () =>
    $scope.Model.availableNonBorrowingSpouses?.length ===
      $scope.Model.availablePersonOnlyContacts?.length &&
    $scope.Model.availablePersonOnlyContacts?.length === $scope.Model.availableContacts?.length;

  $scope.areAllClientsSecurityGuarantor = () =>
    $scope.Model.availableSecurityGuarantors?.length ===
      $scope.Model.availablePersonOnlyContacts?.length &&
    $scope.Model.availablePersonOnlyContacts?.length === $scope.Model.availableContacts?.length;

  $scope.areAllClientsCompanyAndSecurityGuarantor = () => {
    const clients = $scope.Model.availableCompanyOnlyContacts.concat(
      $scope.Model.availableSecurityGuarantors
    );
    return clients?.length === $scope.Model.availableContacts?.length;
  };

  $scope.areAllClientsServicingGuarantor = () =>
    $scope.Model.availableServicingGuarantors?.length ===
      $scope.Model.availablePersonOnlyContacts?.length &&
    $scope.Model.availablePersonOnlyContacts?.length === $scope.Model.availableContacts?.length;

  $scope.allContactsAreCompanies = () =>
    _.every($scope.Model.availableContacts, (c) => c.isCompany);

  $scope.showIncome = () =>
    ($scope.Model.availablePersonOnlyContacts.length > 0 &&
      !$scope.areAllClientsSecurityGuarantor()) ||
    ($scope.Model.availablePersonOnlyContacts.length &&
      $scope.Model.availableContacts.length === 1 &&
      !helperService.isClientSecurityGuarantor({
        ticketClientTypes: $scope.Model.currentTicket.ticketClientTypes,
        idContact: $scope.Model.availablePersonOnlyContacts[0].id
      })) ||
    $scope.allContactsAreCompanies();

  $scope.showExpenses = () => !$scope.allContactsAreCompanies();

  $scope.showObjectivesInsurancesAndOtherAdvisers = () =>
    ($scope.Model.availablePersonOnlyContacts.length > 0 &&
      !$scope.areAllClientsSecurityGuarantor() &&
      !$scope.areAllClientsServicingGuarantor()) ||
    ($scope.Model.availablePersonOnlyContacts.length &&
      $scope.Model.availableContacts.length === 1 &&
      !helperService.isClientSecurityGuarantor({
        ticketClientTypes: $scope.Model.currentTicket.ticketClientTypes,
        idContact: $scope.Model.availablePersonOnlyContacts[0].id
      }) &&
      !helperService.isClientServicingGuarantor({
        ticketClientTypes: $scope.Model.currentTicket.ticketClientTypes,
        idContact: $scope.Model.availablePersonOnlyContacts[0].id
      }) &&
      !helperService.isClientNonBorrowingSpouse({
        ticketClientTypes: $scope.Model.currentTicket.ticketClientTypes,
        idContact: $scope.Model.availablePersonOnlyContacts[0].id
      })) ||
    $scope.allContactsAreCompanies();

  $scope.getLabel = (idLabel) =>
    _.find($scope.Model.availableFileLabels, (l) => l.id === idLabel);

  $scope.isThereAnyContactWhoIsCompanyOrSelfEmployed = () =>
    isThereAnyContactWhoIsCompanyOrSelfEmployed($scope.Model.availableContacts);

  $scope.areAllContactsCompanies = () =>
    areAllContactsCompanies($scope.Model.availableContacts);

  $scope.getContact = (idContact) =>
    $scope.Model.availableContacts.find((c) => c.id === idContact);

  $scope.showApplicationPdf = () =>
    helperService.showOptionForCreatingPdfApplication({
      workflow: $scope.Model.currentWorkflow || {},
      hasAssetFinanceTools: $scope.hasAssetFinanceTools()
    });

  $scope.createAssetFinanceToolPdf = ({ pdfType, isView }) => {
    if (pdfType === $scope.Model.availablePdfTypes[0]) {
      const alert = helperService.showAlertForCreatingPdfApplication({
        products: $scope.Model.currentAssetFinance?.compareProducts || [],
        compliance: $scope.Model.currentAssetFinance?.compliance || [],
        objectives: $scope.Model.currentTicket?.objectives || {},
        commission: $scope.Model.currentAssetFinance?.commission || {},
        workflow: $scope.Model.currentWorkflow || {},
        hasAssetFinanceTools: $scope.hasAssetFinanceTools(),
        isDocument: true
      });
      if (alert?.alerts?.length) {
        const titleStartWord = isView ? 'View' : 'Save';
        alert.title =
          $scope.Model.organizationCountry.cca2 !== 'NZ'
            ? `Error - ${titleStartWord} application summary`
            : `Error - ${titleStartWord} application form`;
        eventService.alertDialog({ alert });
      } else {
        pdfService.createPdf({
          contacts: $scope.Model.availableContacts,
          contactLabels: $scope.Model.availableContactLabels,
          lenders: $scope.Model.availableLendersPerCountry,
          ticket: $scope.Model.currentTicket,
          ticketOwner: $scope.Model.currentTicketOwner,
          loan: $scope.Model.currentAssetFinance,
          workflow: $scope.Model.currentWorkflow,
          pdfType,
          isView
        });
      }
    }
    if (pdfType === $scope.Model.availablePdfTypes[1]) {
      pdfService.createPdf({
        contacts: $scope.Model.availableContacts,
        contactLabels: $scope.Model.availableContactLabels,
        lenders: $scope.Model.availableLendersPerCountry,
        ticket: $scope.Model.currentTicket,
        ticketOwner: $scope.Model.currentTicketOwner,
        loan: $scope.Model.currentAssetFinance,
        workflow: $scope.Model.currentWorkflow,
        pdfType,
        isView
      });
    }
    if (pdfType === $scope.Model.availablePdfTypes[8]) {
      pdfService.createPdf({
        lenders: $scope.Model.availableLenders,
        documents: $scope.Model.availableLendersDocuments,
        ticket: $scope.Model.currentTicket,
        ticketOwner: $scope.Model.currentTicketOwner,
        loan: $scope.Model.currentAssetFinance,
        workflow: $scope.Model.currentWorkflow,
        pdfType,
        isView
      });
    }
  };

  /*
   * Asset finance ~ Income
   * --------------------------------------------------------------------------------
   */
  $scope.incomeAdd = (incomeType, idContact, idEmployer) => {
    incomeService.incomeAdd(
      $scope.Model.currentTicket.income,
      incomeType,
      idContact,
      idEmployer
    );
    if (idContact && idEmployer) {
      $scope.saveIncome({ income: $scope.Model.currentTicket?.income || [] });
    }
  };

  $scope.saveIncome = (data) => {
    $scope.saveTicket({ income: data?.income || [], tCD: data?.tCD || '' });
  };

  /*
   * Asset finance ~ Expenses
   * --------------------------------------------------------------------------------
   */
  $scope.saveExpenses = (data) => {
    $scope.saveTicket({ expenses: data?.expenses || [], tCD: data?.tCD || '' });
  };

  /*
   * Asset finance ~ Assets
   * --------------------------------------------------------------------------------
   */
  $scope.assetAdd = (assetType) => {
    assetsService.assetAdd(
      $scope.Model.currentTicket.assets,
      assetType,
      $scope.Model.availableContacts
    );
  };

  $scope.contactsHaveAssets = () =>
    _.some($scope.Model.availableContacts, (c) => c.assets.length);

  $scope.addContactAssets = (data) => {
    if (data instanceof Asset) {
      const asset = data;
      $scope.addContactAsset(asset);
    }
    if (data instanceof Contact) {
      const contact = data;
      for (let a = 0; a < contact.assets.length; a += 1) {
        const asset = contact.assets[a];
        $scope.addContactAsset(asset);
      }
    }
  };

  $scope.addContactAsset = (assetToAdd) => {
    const asset = assetToAdd;
    for (let i = 0; i < $scope.Model.availableContacts.length; i += 1) {
      const idx = helperService.findIndexByContactId(
        asset.ownership,
        $scope.Model.availableContacts[i].id
      );
      if (idx === -1) {
        asset.ownership.push(Ownership.blank($scope.Model.availableContacts[i].id, 0));
      }
    }
    const idAssets = _.uniq(_.map($scope.Model.currentTicket.assets, 'id'));
    if (idAssets.indexOf(asset.idReference) === -1) {
      asset.idReference = asset.id;
      $scope.Model.currentTicket.assets.push(Asset.build(asset));
      contactsService.clearCache($scope.Model.currentTicket.assets);
      $scope.saveAssets({ assets: $scope.Model.currentTicket.assets, tCD: 'assets' });
    } else {
      uiService.toast({
        text: {
          p1: 'Asset',
          p2: asset.getName(),
          p3: 'has already been added'
        },
        warn: true
      });
    }
  };

  $scope.saveAssets = (data) => {
    $scope.saveTicket({ assets: data?.assets || [], tCD: data?.tCD || '' });
  };

  /*
   * Asset finance ~ Liabilities
   * --------------------------------------------------------------------------------
   */
  $scope.getLiabilityTypes = () => {
    $scope.Model.availableLiabilityTypes = liabilitiesService.getLiabilityTypes(
      $scope.Model.currentTicket.assets
    );
  };

  $scope.liabilityAdd = (liabilityType) => {
    liabilitiesService.liabilityAdd(
      $scope.Model.currentTicket.liabilities,
      liabilityType,
      $scope.Model.availableContacts
    );
  };

  $scope.contactsHaveLiabilities = () =>
    _.some($scope.Model.availableContacts, (c) => c.liabilities.length);

  $scope.addContactLiabilities = (data) => {
    if (data instanceof Liability) {
      const liability = data;
      $scope.addContactLiability(liability);
    }
    if (data instanceof Contact) {
      const contact = data;
      for (let l = 0; l < contact.liabilities.length; l += 1) {
        const liability = contact.liabilities[l];
        $scope.addContactLiability(liability);
      }
    }
  };

  $scope.addContactLiability = (liabilityToAdd) => {
    const liability = liabilityToAdd;
    for (let i = 0; i < $scope.Model.availableContacts.length; i += 1) {
      const idx = helperService.findIndexByContactId(
        liability.ownership,
        $scope.Model.availableContacts[i].id
      );
      if (idx === -1) {
        liability.ownership.push(Ownership.blank($scope.Model.availableContacts[i].id, 0));
      }
    }
    const idLiabilities = _.uniq(_.map($scope.Model.currentTicket.liabilities, 'id'));
    if (idLiabilities.indexOf(liability.idReference) === -1) {
      liability.idReference = liability.id;
      $scope.Model.currentTicket.liabilities.push(Liability.build(liability));
      contactsService.clearCache();
      $scope.saveLiabilities({
        liabilities: $scope.Model.currentTicket.liabilities,
        tCD: 'liabilities'
      });
    } else {
      uiService.toast({
        text: {
          p1: 'Liability',
          p2: liability.getName(),
          p3: 'has already been added'
        },
        warn: true
      });
    }
  };

  $scope.saveLiabilities = (data) => {
    $scope.saveTicket({ liabilities: data?.liabilities || [], tCD: data?.tCD || '' });
  };

  /*
   * Asset finance - Asset commitment schedule
   * --------------------------------------------------------------------------------
   */
  $scope.canAddAssetCommitmentSchedule = () =>
    $scope.Model.currentTicket.assetCommitmentSchedules.length <
    $scope.Model.availableCompanyOnlyContacts.length;

  $scope.assetCommitmentScheduleAdd = () => {
    $scope.Model.currentTicket.assetCommitmentSchedules =
      assetFinanceService.assetCommitmentScheduleAdd(
        $scope.Model.currentTicket.assetCommitmentSchedules
      );
    $scope.saveAssetCommitmentSchedules($scope.Model.currentTicket.assetCommitmentSchedules);
  };

  $scope.saveAssetCommitmentSchedules = $mdUtil.debounce((assetCommitmentSchedules) => {
    if (assetCommitmentSchedules) {
      $scope.Model.currentTicket.assetCommitmentSchedules = assetCommitmentSchedules;
      $scope.saveTicket({ assetCommitmentSchedules });
    }
  }, 1500);

  /*
   * Asset finance ~ Open banking
   * --------------------------------------------------------------------------------
   */
  $scope.showOpenBankingData = (event, type) => {
    eventService.dialogOpenBanking({
      event,
      contacts: $scope.Model.openBankingContacts || [],
      openBankingData: $scope.Model.openBankingData || [],
      openBankingDataType: type,
      ticket: $scope.Model.currentTicket
    });
  };

  $scope.hasData = (type) => _.some($scope.Model.openBankingData || [], (o) => o[type]?.length);

  $scope.openBankingFinished = (data) => {
    if (data?.type && data?.selectedData?.length) {
      const updatedData = helperService.processOpenBankingData({
        data,
        ticket: $scope.Model.currentTicket,
        contacts: $scope.Model.availableContacts
      });
      if (updatedData) {
        $scope.Model.currentTicket[data?.type] = updatedData;
        $scope.saveTicket({
          [data?.type]: $scope.Model.currentTicket[data?.type],
          tCD: data?.type
        });
      }
    }
  };

  /*
   * Asset finance ~ Objectives
   * --------------------------------------------------------------------------------
   */
  $scope.saveObjectives = $mdUtil.debounce((objectives) => {
    $scope.saveTicket({ objectives });
  }, 1500);

  /*
   * Asset finance ~ Insurance
   * --------------------------------------------------------------------------------
   */
  $scope.getInsuranceTypes = () => {
    $scope.Model.availableInsuranceTypes = insurancesService.getInsuranceTypes({
      assets: $scope.Model.currentTicket?.assets || [],
      assetCommitmentSchedules: $scope.Model.currentTicket?.assetCommitmentSchedules || [],
      workflow: $scope.Model.currentWorkflow,
      isCommercial: $scope.Model.currentAssetFinance?.isCommercial || false
    });
  };

  $scope.canSeeInsuranceType = (insuranceType) =>
    insurancesService.canSeeInsuranceType(insuranceType);

  $scope.insuranceAdd = (insuranceType) => {
    insurancesService.insuranceAdd($scope.Model.currentTicket.insurances, insuranceType);
  };

  $scope.contactsHaveInsurance = () =>
    _.some($scope.Model.availableContacts, (c) => c.insurances.length);

  $scope.addContactInsurances = (data) => {
    if (data instanceof Insurance) {
      const insurance = data;
      $scope.addContactInsurance(insurance);
    }
    if (data instanceof Contact) {
      const contact = data;
      for (let l = 0; l < contact.insurances.length; l += 1) {
        const insurance = contact.insurances[l];
        $scope.addContactInsurance(insurance);
      }
    }
  };

  $scope.addContactInsurance = (insuranceToAdd) => {
    const insurance = insuranceToAdd;
    for (let i = 0; i < $scope.Model.availableContacts.length; i += 1) {
      if (insurance.idContacts.indexOf($scope.Model.availableContacts[i].id) === -1) {
        insurance.idContacts.push($scope.Model.availableContacts[i].id);
      }
    }
    const idInsurances = _.uniq(_.map($scope.Model.currentTicket.insurances, 'id'));
    if (idInsurances.indexOf(insurance.idReference) === -1) {
      insurance.idReference = insurance.id;
      $scope.Model.currentTicket.insurances.push(Insurance.build(insurance));
      contactsService.clearCache();
      $scope.saveInsurances($scope.Model.currentTicket.insurances);
    } else {
      uiService.toast({
        text: {
          p1: 'Insurance',
          p2: insurance.getName(),
          p3: 'has already been added'
        },
        warn: true
      });
    }
  };

  $scope.saveInsurances = $mdUtil.debounce((insurances) => {
    $scope.saveTicket({ insurances });
  }, 1500);

  /*
   * Asset finance ~ Other advisers
   * --------------------------------------------------------------------------------
   */
  $scope.getOtherAdviserTypes = () => {
    $scope.Model.availableOtherAdviserTypes =
      otherAdvisersService.getAvailableOtherAdviserTypes({
        workflow: $scope.Model.currentWorkflow
      });
  };

  $scope.otherAdviserAdd = (otherAdviserType) => {
    otherAdvisersService.otherAdviserAdd(
      $scope.Model.currentTicket.otherAdvisers,
      otherAdviserType
    );
  };

  $scope.saveOtherAdvisers = $mdUtil.debounce((otherAdvisers) => {
    $scope.saveTicket({ otherAdvisers });
  }, 1500);

  /*
   * Asset finance ~ All addresses
   * --------------------------------------------------------------------------------
   */
  $scope.getAllAddresses = () => {
    $scope.Model.availableAddresses = helperService.getAllAddresses(
      $scope.Model.availableContacts,
      $scope.Model.currentTicket.assets,
      $scope.Model.currentTicket.otherAdvisers,
      $scope.Model.currentTicketOwner,
      $scope.Model.currentWorkflow,
      $scope.isDealOwnerBroker(),
      $scope.Model.currentAssetFinance.compliance
    );
  };

  /*
   * Asset finance - Details
   * --------------------------------------------------------------------------------
   */
  $scope.changeSelectedItemOfVendor = (assetToUpdate, selectedContact) => {
    const asset = assetFinanceService.changeSelectedItemOfVendor({
      assetToUpdate,
      selectedContact
    });
    const idx = helperService.findIndexById(
      $scope.Model.currentAssetFinance.assetDetails,
      asset.id
    );
    if (idx > -1) {
      $scope.Model.currentAssetFinance.assetDetails[idx] = asset;
      $scope.saveAssetDetails({ assetDetails: $scope.Model.currentAssetFinance.assetDetails });
    }
  };

  $scope.toggleUnsecured = (isUnsecured) => {
    $scope.Model.currentAssetFinance.isUnsecured = isUnsecured || false;
    if ($scope.Model.currentAssetFinance.isUnsecured) {
      $scope.Model.currentAssetFinance.assetDetails = [];
      $scope.Model.currentAssetFinance.additionalProduct = AssetFinanceInsurance.Blank();
    } else {
      $scope.Model.currentAssetFinance.assetDetails = assetFinanceService.assetDetailsAdd({
        assetDetails: [],
        quickQuoteAssetDetails: []
      });
    }
    $scope.saveAssetFinance({
      isUnsecured,
      assetDetails: $scope.Model.currentAssetFinance.assetDetails,
      additionalProduct: $scope.Model.currentAssetFinance.additionalProduct
    });
  };

  $scope.saveAssetDetails = (data) => {
    if (data?.assetDetails) {
      $scope.Model.currentAssetFinance.assetDetails = _.map(
        _.compact(data?.assetDetails || []),
        (assetDetail) => AssetFinanceDetail.Build(assetDetail)
      );
    }
    if (!_.isEmpty(data?.additionalProduct)) {
      $scope.Model.currentAssetFinance.additionalProduct = AssetFinanceInsurance.Build(
        data.additionalProduct
      );
    }
    if (!_.isEmpty(data?.financeProposal)) {
      $scope.Model.currentAssetFinance.financeProposal = AssetFinanceProposal.Build(
        data.financeProposal
      );
    }
    $scope.Model.currentAssetFinance.isUnsecured = data?.isUnsecured || false;
    if (data && !_.isEmpty(data)) {
      $scope.saveAssetFinance(data);
    }
  };

  /*
   * Asset finance ~ Lender and product
   * --------------------------------------------------------------------------------
   */
  $scope.saveLenderAndProduct = (data) => {
    if (!_.isEmpty(data?.searchFields)) {
      $scope.Model.currentAssetFinance.searchFields = AssetFinanceSearchProduct.Build(
        data.searchFields
      );
    }
    if (data?.compareProducts) {
      $scope.Model.currentAssetFinance.compareProducts = _.map(
        _.compact(data?.compareProducts || []),
        (compareProduct) => AssetFinanceCompareProduct.Build(compareProduct)
      );
    }
    if (!_.isEmpty(data)) {
      $scope.saveAssetFinance(data);
    }
  };

  /*
   * Asset finance - Compare products
   * --------------------------------------------------------------------------------
   */
  $scope.toggleProductAsPreferred = (idx) => {
    if (idx > -1) {
      $scope.Model.currentAssetFinance.compareProducts[idx].isPreferred =
        !$scope.Model.currentAssetFinance.compareProducts[idx].isPreferred;
      const totalAssetCost = _.reduce(
        $scope.Model.currentAssetFinance?.assetDetails || [],
        (memo, num) => _.add(memo + _.toNumber(num?.cost || 0)),
        0
      );
      const totalAssetNetCost = _.reduce(
        $scope.Model.currentAssetFinance?.assetDetails || [],
        (memo, num) => _.add(memo + _.toNumber(num?.netCost || 0)),
        0
      );
      $scope.Model.currentAssetFinance.financeProposal = AssetFinanceProposal.Blank();
      $scope.Model.currentAssetFinance.financeProposal.totalAssetCost = totalAssetCost;
      $scope.Model.currentAssetFinance.financeProposal.totalAssetNetCost = totalAssetNetCost;
      $scope.saveAssetFinance({
        compareProducts: $scope.Model.currentAssetFinance.compareProducts,
        financeProposal: $scope.Model.currentAssetFinance.financeProposal
      });
    }
  };

  $scope.updateCompareProducts = (data) => {
    if (data?.compareProducts) {
      $scope.Model.currentAssetFinance.compareProducts = _.map(
        _.compact(data?.compareProducts || []),
        (compareProduct) => AssetFinanceCompareProduct.Build(compareProduct)
      );
    }
  };

  $scope.saveCompareProducts = (data) => {
    $scope.updateCompareProducts(data);
    if (!_.isEmpty(data)) {
      $scope.saveAssetFinance(data);
    }
  };

  /*
   * Asset finance ~ Finance proposal
   * --------------------------------------------------------------------------------
   */
  $scope.saveFinanceProposal = (data) => {
    if (!_.isEmpty(data?.financeProposal)) {
      $scope.Model.currentAssetFinance.financeProposal = AssetFinanceProposal.Build(
        data.financeProposal
      );
    }
    if (!_.isEmpty(data)) {
      $scope.saveAssetFinance(data);
    }
  };

  /*
   * Asset finance ~ Commissions
   * --------------------------------------------------------------------------------
   */
  $scope.saveAssetFinanceCommission = $mdUtil.debounce((commission) => {
    if (commission && !_.isEmpty(commission)) {
      $scope.Model.currentAssetFinance.commission = commission;
      $scope.saveAssetFinance({ commission });
    }
  }, 500);

  /*
   * Asset finance ~ Compliance comments and documents
   * --------------------------------------------------------------------------------
   */
  $scope.verificationsApplicantsIdentified = () => {
    if (
      $scope.Model.currentTicket?.objectives?.needsAndObjectives?.notes &&
      !$scope.Model.currentAssetFinance?.compliance?.comments
        ?.analysisAssessmentAndApplicantEducation
    ) {
      $scope.Model.currentAssetFinance.compliance.comments.analysisAssessmentAndApplicantEducation =
        $scope.Model.currentTicket?.objectives?.needsAndObjectives?.notes;
    }
    if ($scope.Model.availablePersonOnlyContacts?.length) {
      if (!$scope.Model.currentAssetFinance?.compliance?.verifications?.applicants) {
        $scope.Model.currentAssetFinance.compliance.verifications.applicants = [];
      }
      const len = $scope.Model.availablePersonOnlyContacts?.length || 0;
      for (let i = 0; i < len; i += 1) {
        const applicant = $scope.Model.availablePersonOnlyContacts[i];
        const idx = _.findIndex(
          $scope.Model.currentAssetFinance?.compliance?.verifications?.applicants || [],
          (a) => a?.idContact === applicant?.id
        );
        if (idx === -1) {
          $scope.Model.currentAssetFinance.compliance.verifications.applicants.push(
            AssetFinanceVerificationApplicant.Blank(applicant?.id)
          );
        }
      }
    }
    const data = {
      compliance: $scope.Model.currentAssetFinance.compliance
    };
    $scope.saveCompliance(data);
  };

  $scope.updateCompliance = (data) => {
    if (!_.isEmpty(data?.compliance)) {
      $scope.Model.currentAssetFinance.compliance = AssetFinanceCompliance.Build(
        data.compliance
      );
    }
  };

  $scope.saveCompliance = (data) => {
    if (!_.isEmpty(data?.compliance)) {
      $scope.updateCompliance(data);
      $scope.saveAssetFinance({
        compliance: $scope.Model.currentAssetFinance.compliance,
        aFCD: data?.aFCD || ''
      });
    }
    if (!_.isEmpty(data?.objectives)) {
      const obj = data.objectives;
      $scope.Model.currentTicket.objectives = obj;
      $scope.saveTicket({ objectives: $scope.Model.currentTicket.objectives });
    }
  };

  /*
   * Asset finance ~ Mentor approval
   * --------------------------------------------------------------------------------
   */
  $scope.saveTicketStatusHistory = $mdUtil.debounce((statusHistory) => {
    if (statusHistory) {
      notesService.clearCache();
      $scope.Model.currentTicket.statusHistory.push(statusHistory);
      $scope.Model.currentTicket.isReadyForVerification = statusHistory.isReadyForVerification;
      $scope.Model.currentTicket.isVerified = statusHistory.isVerified;
      uiService.toast({
        text: {
          p1: 'Deal',
          p2: $scope.Model.currentTicket.getName(),
          p3: 'has been changed status'
        }
      });
      $scope.saveTicket({
        isReadyForVerification: $scope.Model.currentTicket.isReadyForVerification,
        isVerified: $scope.Model.currentTicket.isVerified,
        statusHistory: $scope.Model.currentTicket.statusHistory
      });
    }
  }, 500);

  /*
   * Asset finance ~ Lodgement
   * --------------------------------------------------------------------------------
   */
  $scope.isLodgementEnabled = () =>
    lodgementService.isAnyLodgementEnabled() &&
    ($scope.isDealOwnerMentee() ? $scope.Model.currentTicket.isVerified : true);

  /*
   * Asset finance ~ Create documents
   * --------------------------------------------------------------------------------
   */
  $scope.areAllRequiredComplianceDocumentsAdded = () =>
    homeLoanService.areAllRequiredComplianceDocumentsAdded(
      $scope.Model.attachmentsCompliance,
      $scope.Model.availableFileLabels
    );

  $scope.hasBasisForRecommendationFilled = () =>
    assetFinanceService.hasBasisForRecommendationFilled($scope.Model.currentAssetFinance);

  $scope.mergeDocuments = ({ documents, isSpecific, filterByContact }) => {
    const deferred = $q.defer();
    if (isSpecific) {
      documentService
        .mergeSpecificDocument({
          idTicket: $scope.Model.currentTicket.id,
          documents
        })
        .then((res) => {
          deferred.resolve(res);
        });
    } else {
      const idDocuments = _.compact(_.map(documents, 'id'));
      documentService
        .mergeDocument({
          idWorkflow: $scope.Model.currentWorkflow.id,
          idStage: $scope.Model.currentTicket.idStage,
          idTicket: $scope.Model.currentTicket.id,
          idDocuments,
          filterByContact
        })
        .then((res) => {
          deferred.resolve(res);
        });
    }
    return deferred.promise;
  };

  $scope.createDocuments = ({ event }) =>
    eventService.mergeDocuments({
      event,
      complianceFileLabels: $scope.Model.availableComplianceFileLabels,
      documents: $scope.Model.availableDocuments,
      specificDocuments: [],
      ticket: $scope.Model.currentTicket,
      workflow: $scope.Model.currentWorkflow,
      lenders: $scope.Model.filteredLenders,
      validationErrors: $scope.Model.validation.bidErrors,
      assetFinance: $scope.Model.currentAssetFinance,
      hasAssetFinanceTools: $scope.hasAssetFinanceTools()
    });

  $scope.createDocumentsFinished = (data) => {
    if (data && data?.documents?.length) {
      uiService.toast({
        text: {
          p1: 'Document(s) template',
          p2: 'is being prepared',
          p3: 'please wait ...'
        },
        progress: true
      });
      $scope
        .mergeDocuments({
          documents: data?.documents || [],
          isSpecific: data?.isSpecific || false,
          filterByContact: data?.filterByContact || ''
        })
        .then((res) => {
          notesService.clearCache();
          if (!res.status) {
            uiService.toast({
              text: {
                p1: 'Document(s)',
                p2: 'create',
                p3: 'has failed'
              },
              warn: true
            });
          } else {
            loadNotes().then(() => {
              loadAttachments($scope.Model.availableNotes);
              $timeout(() => {
                uiService.toast({
                  text: {
                    p1: 'Document(s)',
                    p2: 'created',
                    p3: 'successfully'
                  }
                });
              });
            });
          }
        });
    }
  };

  $scope.onGatewaySelected = (gateway) => {
    $scope.Model.currentGateway = gateway;
  };

  $scope.onValidated = (validationErrors) => {
    $scope.Model.validation.errors = validationErrors;
    const cLen = $scope.Model.availableContacts?.length || 0;
    for (let c = 0; c < cLen; c += 1) {
      const contact = $scope.Model.availableContacts[c];
      $scope.Model.validation[`applicant${c}Errors`] = _.filter(
        validationErrors,
        (v) => v?.idContact === contact.id
      );
    }
    $scope.Model.validation.incomeErrors = _.filter(
      validationErrors,
      (v) => v?.message?.toLowerCase()?.indexOf('income -') > -1
    );
    $scope.Model.validation.expensesErrors = _.filter(
      validationErrors,
      (v) => v?.message?.toLowerCase()?.indexOf('expenses -') > -1
    );
    $scope.Model.validation.assetsErrors = _.filter(
      validationErrors,
      (v) => v?.message?.toLowerCase()?.indexOf('assets -') > -1
    );
    $scope.Model.validation.liabilitiesErrors = _.filter(
      validationErrors,
      (v) => v?.message?.toLowerCase()?.indexOf('liabilities -') > -1
    );
    $scope.Model.validation.needsAndObjectivesErrors = _.filter(
      validationErrors,
      (v) => v?.message?.toLowerCase()?.indexOf('needs and objectives -') > -1
    );
    $scope.Model.validation.securityDetailsErrors = _.filter(
      validationErrors,
      (v) => v?.message?.toLowerCase()?.indexOf('security details -') > -1
    );
    $scope.Model.validation.assetToBeFinancedErrors = _.filter(
      validationErrors,
      (v) => v?.message?.toLowerCase()?.indexOf('asset to be financed -') > -1
    );
    $scope.Model.validation.bidErrors = $scope.Model.validation?.needsAndObjectivesErrors;
  };

  $scope.validate = () => {
    if (
      !$scope.Model.currentAssetFinance?.isCommercial &&
      _.isEmpty($scope.Model.currentGateway) &&
      $scope.Model.organizationCountry?.cca2 !== 'NZ'
    ) {
      const errors = validationService.validate({
        type: 'af',
        ticket: $scope.Model.currentTicket
      });
      $scope.Model.validation.errors = errors?.validationErrors || [];
    }
    if ($scope.Model.validation?.errors?.length && !_.isEmpty($scope.Model.currentGateway)) {
      const idLenders = _.compact(_.uniq(_.map($scope.Model.filteredLenders, 'id')));
      const accreditation = _.find(
        $scope.Model.currentTicketOwner?.lenderAccreditations || [],
        (l) => idLenders?.indexOf(l.idLender) > -1
      );
      const errors = $scope.Model.currentGateway.isMinimumFieldsFilled({
        accreditation,
        contacts: $scope.Model.availableContacts || [],
        currentTicketOwner: $scope.Model.currentTicketOwner || {},
        securitySplits: $scope.Model.currentHomeLoan?.securityDetails?.securitySplits || [],
        ticket: $scope.Model.currentTicket || {},
        loan: $scope.Model.currentAssetFinance
      });
      $scope.Model.validation.errors = errors?.validationErrors || [];
    }
    $scope.onValidated($scope.Model.validation.errors);
  };

  /*
   * Asset finance ~ Back
   * --------------------------------------------------------------------------------
   */
  $scope.back = () => {
    $state.transitionTo('deal', { id: $stateParams.id, dd: $stateParams.dd });
  };

  /*
   * Asset finance ~ Save Contact
   * --------------------------------------------------------------------------------
   */
  $scope.saveContact = $mdUtil.debounce((contact) => {
    $scope.validate();
    if (!$scope.Model.currentTicket.isSettled) {
      $scope.getAllAddresses();
      if (contact.getName() !== 'N/A') {
        contactService.updateContact(contact).then((data) => {
          contactsService.clearCache();
          if (data.status) {
            uiService.toast({
              text: {
                p1: 'Contact',
                p2: contact.getName(),
                p3: 'has been updated'
              },
              success: true
            });
          }
        });
      } else {
        uiService.toast({
          text: {
            p1: 'Contact',
            p2: contact.isCompany ? 'Name' : 'First name and family name',
            p3: contact.isCompany ? 'is required' : 'are required'
          },
          warn: true
        });
      }
    }
  }, 1500);

  /*
   * Asset finance ~ Save Ticket
   * --------------------------------------------------------------------------------
   */
  $scope.saveTicket = (data) => {
    $scope.validate();
    const ticket = data;
    const tCD = data?.tCD || '';
    if (data?.tCD !== undefined) {
      delete ticket.tCD;
    }
    if (!$scope.Model.currentTicket.isSettled) {
      $scope.getAllAddresses();
      ticket.id = $scope.Model.currentTicket.id;
      ticket.name = $scope.Model.currentTicket.name;
      ticketService.updateTicket(ticket).then((result) => {
        ticketsService.clearCache();
        if (result.status) {
          uiService.toast({
            text: {
              p1: 'Deal',
              p2: $scope.Model.currentTicket.getName(),
              p3: 'has been updated'
            },
            success: true
          });
        }
        eventService.changedData({ changedData: tCD });
      });
    }
  };

  /*
   * Asset finance ~ Save Asset finance
   * --------------------------------------------------------------------------------
   */
  $scope.saveAssetFinance = (data) => {
    $scope.validate();
    const assetFinance = data;
    const aFCD = data?.aFCD || '';
    if (data?.aFCD !== undefined) {
      delete assetFinance.aFCD;
    }
    if (!$scope.Model.currentTicket.isSettled) {
      $scope.Model.currentAssetFinance.deleteDateObject();
      assetFinance.id = $scope.Model.currentAssetFinance.id;
      if (!assetFinance.id) {
        assetFinanceService
          .createAssetFinance($scope.Model.currentAssetFinance)
          .then((result) => {
            if (result.status) {
              $scope.Model.currentAssetFinance.id = result.id;
              $scope.Model.currentTicket.idAssetFinance = result.id;
              $scope.saveTicket({
                idAssetFinance: $scope.Model.currentTicket.idAssetFinance
              });
              uiService.toast({
                text: {
                  p1: 'Asset finance for deal',
                  p2: $scope.Model.currentTicket.getName(),
                  p3: 'has been created'
                },
                success: true
              });
            }
          });
      } else {
        assetFinanceService.updateAssetFinancePartial(assetFinance).then((result) => {
          if (result.status) {
            uiService.toast({
              text: {
                p1: 'Asset finance for deal',
                p2: $scope.Model.currentTicket.getName(),
                p3: 'has been updated'
              },
              success: true
            });
          }
          eventService.changedData({ changedData: aFCD });
        });
      }
    }
  };
};
